module.exports = __webpack_public_path__ + "img/png-ic.dea9067c.svg";